/* /src/components/auth/silentRenew.jsx */

import React from "react";

import { AuthConsumer } from "../../Providers/AuthProvider";

export const SilentRenew = () => (
    <AuthConsumer>
        {({ signinSilentCallback }) => {
            signinSilentCallback();
            return <span></span>;
        }}
    </AuthConsumer>
);